// Event-bus health (event-processor via the gateway). Platform Operations Console P2.
// Cross-tenant aggregate of outbox backlog / publish-lag + the shared DLQ.
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);

export interface ServiceOutboxHealth {
  service: string;
  schema: string;
  pending: number;
  stuck: number;
  published_24h: number;
  oldest_pending_age_seconds: number;
}

export interface LabelCount {
  label: string;
  count: number;
}

export interface DlqHealth {
  available: boolean;
  total: number;
  last_24h: number;
  by_producer: LabelCount[];
  by_event_type: LabelCount[];
}

export interface EventBusHealth {
  generated_at: string;
  status: 'operational' | 'degraded' | 'critical';
  totals: { pending: number; stuck: number; published_24h: number; dlq: number };
  max_attempts: number;
  services: ServiceOutboxHealth[];
  dlq: DlqHealth;
  notes?: string[];
}

export const getEventBusHealth = () =>
  axios.get<EventBusHealth>(`${API_V1}/eventbus/platform/health`).then((r) => r.data);
